import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchFieldProps {
  initialValue?: string;
  placeholder?: string;
  tone?: "light" | "dark";
  compact?: boolean;
}

export default function SearchField({
  initialValue = "",
  placeholder = "搜索剧情、演员、资讯",
  tone = "light",
  compact = false,
}: SearchFieldProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const toneClass =
    tone === "dark"
      ? "bg-background-50/10 border-background-50/25 text-background-50 placeholder:text-background-50/60 focus-within:border-accent-400"
      : "bg-background-100 border-background-200 text-foreground-900 placeholder:text-foreground-400 focus-within:border-primary-300";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex w-full items-center gap-2 rounded-full border px-4 transition-colors ${toneClass} ${
        compact ? "h-9" : "h-11"
      }`}
    >
      <i
        className={`ri-search-line shrink-0 ${compact ? "text-sm" : "text-base"} ${
          tone === "dark" ? "text-background-50/70" : "text-foreground-400"
        }`}
      />
      <input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="站内搜索"
        className={`h-full w-full bg-transparent text-sm outline-none ${tone === "dark" ? "text-background-50" : "text-foreground-900"}`}
      />
      <button
        type="submit"
        className={`shrink-0 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
          tone === "dark"
            ? "bg-accent-500 text-foreground-950 hover:bg-accent-400"
            : "bg-primary-500 text-background-50 hover:bg-primary-600"
        }`}
      >
        搜索
      </button>
    </form>
  );
}